const SupLoader = ({ label = "Loading..." }) => {
  return (
    <div className="sup-loader">
      <div className="sup-loader__spinner" />
      <p className="sup-loader__label">{label}</p>
    </div>
  );
};

export default SupLoader;
